
import Vue from 'vue';
import Component from 'vue-class-component';

import { Bar, mixins } from 'vue-chartjs';
import { ChartOptions, ChartData } from 'chart.js';
import { Prop, Mixins } from 'vue-property-decorator';

@Component
export default class VueBarChart extends Mixins(Bar, mixins.reactiveProp) {
    @Prop({ default: () => { return null; }}) options: ChartOptions|undefined;
    @Prop() chartData!: ChartData; 

    mounted() {
        this.renderChart(this.chartData, this.options);
    }
};
